export default __webpack_public_path__ + "media/storefront/img/guarantee-badge-f07471ca950329589259fbbcf3392b65.png";